import React, { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // ✅ Disable browser scroll restoration + force scroll to top
    window.history.scrollRestoration = "manual";

    // ✅ Scroll the HTML element directly (works with fixed navbars)
    document.documentElement.scrollTop = 0;
    // Also scroll body (some browsers need both)
    document.body.scrollTop = 0;

    // ✅ Clear any scroll position cache
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
